export enum EvaluationsActionsType {
	SetVisible = 1,
	SetInvisible = 2,
	SetRequired = 3,
	SetNotRequired = 4
}